import Vue, { ComponentOptions, AsyncComponent } from 'vue';

import VueRouter, {RouteConfig} from 'vue-router/types';
import Router from 'vue-router';

type Component = ComponentOptions<Vue> | typeof Vue | AsyncComponent;

export class ZgRouter {
    public vueRouter: VueRouter | null = null;
    public routes: RouteConfig[] = [];

    public createVueRouter() {
        this.vueRouter = new Router({
            mode: 'history',
            routes: this.routes,
        });

        this.vueRouter.beforeEach((to, from, next) => {
            // @ts-ignore
            to.query.lastRoute = from;
            next();
        });
    }

    public addRoute(shortName: string, askedComponent: Component, pathName: string | null = null) {
        let computedPath = '/' + shortName;
        if (pathName !== null) {
            computedPath = pathName;
        }
        this.routes.push({
            name : shortName,
            component : askedComponent,
            path: computedPath,
        });
    }

    public addUrlRedirect(PathName: string, redirectPathName: string) {
        this.routes.push({
            path: PathName,
            redirect : redirectPathName,
        });
    }
}
